import { render } from "./FinanceInvoicesComponent.vue?vue&type=template&id=4ff9a89c&scoped=true"
import script from "./FinanceInvoicesComponent.vue?vue&type=script&lang=js"
export * from "./FinanceInvoicesComponent.vue?vue&type=script&lang=js"

import "./FinanceInvoicesComponent.vue?vue&type=style&index=0&id=4ff9a89c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff9a89c"]])

export default __exports__